module.exports = __webpack_public_path__ + "static/media/refreshgrey.05ac69e0.png";